export enum RpOccurrenceEditProxyFormFieldNamesEnum {
  CustomerCard = 'customerCard',
  NextPaymentDate = 'nextPaymentDate',
}
